import { ApeironButtonDisableTip } from '@apeiron/temp'
import ApeironOperateButton, {
  ApeironOperateButtonProps
} from '@src/components/share/apeiron/ApeironOperateButton'
import { OperateButton } from '@src/constants/variant'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const TradeGiftButton: FC<ApeironOperateButtonProps> = (
  props: ApeironOperateButtonProps
) => {
  const { disabled, disableReason } = props

  const { t } = useTranslation()

  return (
    <ApeironButtonDisableTip disabled={disabled} reason={disableReason}>
      <ApeironOperateButton
        {...props}
        variant={OperateButton.Short}
        label={t('common.button.gift')}
      />
    </ApeironButtonDisableTip>
  )
}

export default TradeGiftButton
